import moment from 'moment';

const initialValues: any = {
  date: [moment().subtract(7, 'days').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
  campaign_id: [],
  affiliate_id: [],
  abandonment: '',
};
export default initialValues;
